import type { CategoryMM } from "~/entities/category";

export type TSearchSuggestionPopularBlock = {
  items: string[];
  blockType: ESearchSuggestionBlockType.popular;
};
export type TSearchSuggestionTextBlock = {
  items: { title: string; isPrevious: boolean }[];
  blockType: ESearchSuggestionBlockType.text;
};
export type TSearchSuggestionCategoryBlock = {
  items: CategoryMM[];
  blockType: ESearchSuggestionBlockType.category;
};

export type TSearchSuggestionShop = {
  avatar: {
    low: string;
  };
  id: number;
  title: string;
  url: string;
};
export type TSearchSuggestionShopBlock = {
  items: TSearchSuggestionShop[];
  blockType: ESearchSuggestionBlockType.shop;
};

export type TSearchSuggestionBlock = TSearchSuggestionPopularBlock | TSearchSuggestionTextBlock | TSearchSuggestionCategoryBlock | TSearchSuggestionShopBlock | TSearchSuggestionSearchedBlock;

export type TSearchSuggestions = {
  blocks: TSearchSuggestionBlock[];
}

export enum ESearchSuggestionBlockType {
  popular = 'popular',
  text = 'text',
  category = 'category',
  shop = 'shop',

  searched = 'searched',
}

export type TSearchSuggestionSearchedBlock = {
  items: string[];
  blockType: ESearchSuggestionBlockType.searched;
};